import { useSearchParams } from 'react-router';
import { useApi, unwrap } from '@remote-medium/ui';

import { admin } from '../../lib/client.ts';
import { PendingRoleTypes } from './components/PendingRoleTypes.tsx';
import { PendingSkills } from './components/PendingSkills.tsx';
import { Page, PageHeader, Tabs } from '../../lib/ui.tsx';

type Kind = 'skills' | 'role-types';

export function SuggestionsPage() {
  const [params, setParams] = useSearchParams();
  const kind = (params.get('tab') as Kind | null) ?? 'skills';
  const { data: counts, reload: reloadCounts } = useApi(
    () =>
      Promise.all([
        unwrap(admin.skills.pending.$get()),
        unwrap(admin['role-types'].pending.$get()),
      ]),
    [kind],
  );

  return (
    <Page className="gap-6">
      <PageHeader
        title="Suggestions"
        description="What candidates and companies asked us to add to the taxonomy."
      />
      <Tabs
        label="Suggestion kind"
        value={kind}
        onChange={(k) => setParams(k === 'skills' ? {} : { tab: k }, { replace: true })}
        tabs={[
          { value: 'skills', label: 'Skills', count: counts?.[0].length },
          { value: 'role-types', label: 'New role types', count: counts?.[1].length },
        ]}
      />
      {kind === 'skills' ? (
        <PendingSkills onReviewed={reloadCounts} />
      ) : (
        <PendingRoleTypes onReviewed={reloadCounts} />
      )}
    </Page>
  );
}
